import type { ScheduleSlot } from '@/lib/api';

// Bundled copy of the published trial-eligible schedule. This keeps the trial
// picker usable during transient production API/rewrite failures.
export const FALLBACK_TRIAL_SLOTS: ScheduleSlot[] = [
  {
    id: 'mon-530-kids-boxing',
    day: 'MONDAY',
    startTime: '5:30 PM',
    endTime: '6:20 PM',
    title: 'Kids Boxing',
    category: 'kids',
    level: 'kids',
    trialEligible: true,
  },
  {
    id: 'mon-530-kids-bjj',
    day: 'MONDAY',
    startTime: '5:30 PM',
    endTime: '6:20 PM',
    title: 'Kids Jiu Jitsu',
    category: 'kids',
    level: 'kids',
    trialEligible: true,
  },
  {
    id: 'mon-620-boxing-fund',
    day: 'MONDAY',
    startTime: '6:20 PM',
    endTime: '8:00 PM',
    title: 'Boxing Fundamentals',
    category: 'boxing',
    level: 'beginners',
    trialEligible: true,
  },
  {
    id: 'mon-620-bjj',
    day: 'MONDAY',
    startTime: '6:20 PM',
    endTime: '8:00 PM',
    title: 'Brazilian Jiu Jitsu Beginners',
    category: 'bjj',
    level: 'mixed',
    trialEligible: true,
  },
  {
    id: 'mon-800-mt-int',
    day: 'MONDAY',
    startTime: '8:00 PM',
    endTime: '9:30 PM',
    title: 'Muay Thai - Intermediate+',
    category: 'muay-thai',
    level: 'intermediate',
    trialEligible: true,
    notes: 'Required 1+ year of experience',
  },
  {
    id: 'mon-800-mma-int',
    day: 'MONDAY',
    startTime: '8:00 PM',
    endTime: '9:15 PM',
    title: 'MMA - Intermediate',
    category: 'mma',
    level: 'intermediate',
    trialEligible: true,
    notes: 'Required 1+ year of experience',
  },
  {
    id: 'tue-1130-mixed',
    day: 'TUESDAY',
    startTime: '11:30 AM',
    endTime: '1:00 PM',
    title: 'Boxing & Muay Thai',
    category: 'mixed',
    level: 'mixed',
    trialEligible: true,
  },
  {
    id: 'tue-530-kids-wrestling',
    day: 'TUESDAY',
    startTime: '5:30 PM',
    endTime: '6:20 PM',
    title: 'Kids Wrestling',
    category: 'kids',
    level: 'kids',
    trialEligible: true,
  },
  {
    id: 'tue-620-mt-fund',
    day: 'TUESDAY',
    startTime: '6:20 PM',
    endTime: '8:00 PM',
    title: 'Muay Thai Fundamentals',
    category: 'muay-thai',
    level: 'beginners',
    trialEligible: true,
  },
  {
    id: 'tue-620-bjj',
    day: 'TUESDAY',
    startTime: '6:20 PM',
    endTime: '8:00 PM',
    title: 'Brazilian Jiu Jitsu',
    category: 'bjj',
    level: 'mixed',
    trialEligible: true,
    notes: 'Required 1+ year of experience',
  },
  {
    id: 'tue-750-boxing-int',
    day: 'TUESDAY',
    startTime: '7:50 PM',
    endTime: '9:30 PM',
    title: 'Boxing - Intermediate+',
    category: 'boxing',
    level: 'intermediate',
    trialEligible: true,
    notes: 'Required 1+ year of experience',
  },
  {
    id: 'tue-800-mma-fighters',
    day: 'TUESDAY',
    startTime: '8:00 PM',
    endTime: '9:15 PM',
    title: 'MMA Fighters',
    category: 'mma',
    level: 'fighters',
    trialEligible: true,
    notes: 'Required 1+ year of experience',
  },
  {
    id: 'wed-530-kids-boxing',
    day: 'WEDNESDAY',
    startTime: '5:30 PM',
    endTime: '6:20 PM',
    title: 'Kids Boxing',
    category: 'kids',
    level: 'kids',
    trialEligible: true,
  },
  {
    id: 'wed-530-kids-bjj',
    day: 'WEDNESDAY',
    startTime: '5:30 PM',
    endTime: '6:20 PM',
    title: 'Kids Jiu Jitsu',
    category: 'kids',
    level: 'kids',
    trialEligible: true,
  },
  {
    id: 'wed-620-boxing-fund',
    day: 'WEDNESDAY',
    startTime: '6:20 PM',
    endTime: '8:00 PM',
    title: 'Boxing Fundamentals',
    category: 'boxing',
    level: 'beginners',
    trialEligible: true,
  },
  {
    id: 'wed-620-bjj',
    day: 'WEDNESDAY',
    startTime: '6:20 PM',
    endTime: '8:00 PM',
    title: 'Brazilian Jiu Jitsu Beginners',
    category: 'bjj',
    level: 'mixed',
    trialEligible: true,
  },
  {
    id: 'wed-800-mt-int',
    day: 'WEDNESDAY',
    startTime: '8:00 PM',
    endTime: '9:30 PM',
    title: 'Muay Thai - Intermediate+',
    category: 'muay-thai',
    level: 'intermediate',
    trialEligible: true,
    notes: 'Required 1+ year of experience',
  },
  {
    id: 'wed-800-mma-int',
    day: 'WEDNESDAY',
    startTime: '8:00 PM',
    endTime: '9:15 PM',
    title: 'MMA - Intermediate',
    category: 'mma',
    level: 'intermediate',
    trialEligible: true,
    notes: 'Required 1+ year of experience',
  },
  {
    id: 'thu-1130-mixed',
    day: 'THURSDAY',
    startTime: '11:30 AM',
    endTime: '1:00 PM',
    title: 'Boxing & Muay Thai',
    category: 'mixed',
    level: 'mixed',
    trialEligible: true,
  },
  {
    id: 'thu-530-kids-wrestling',
    day: 'THURSDAY',
    startTime: '5:30 PM',
    endTime: '6:20 PM',
    title: 'Kids Wrestling',
    category: 'kids',
    level: 'kids',
    trialEligible: true,
  },
  {
    id: 'thu-530-kids-jiu-jitsu',
    day: 'THURSDAY',
    startTime: '5:30 PM',
    endTime: '6:20 PM',
    title: 'Kids Jiu Jitsu',
    category: 'kids',
    level: 'kids',
    trialEligible: true,
  },
  {
    id: 'thu-620-mt-fund',
    day: 'THURSDAY',
    startTime: '6:20 PM',
    endTime: '8:00 PM',
    title: 'Muay Thai Fundamentals',
    category: 'muay-thai',
    level: 'beginners',
    trialEligible: true,
  },
  {
    id: 'thu-620-bjj',
    day: 'THURSDAY',
    startTime: '6:20 PM',
    endTime: '8:00 PM',
    title: 'Brazilian Jiu Jitsu',
    category: 'bjj',
    level: 'mixed',
    trialEligible: true,
    notes: 'Required 1+ year of experience',
  },
  {
    id: 'thu-750-boxing-int',
    day: 'THURSDAY',
    startTime: '7:50 PM',
    endTime: '9:30 PM',
    title: 'Boxing - Intermediate+',
    category: 'boxing',
    level: 'intermediate',
    trialEligible: true,
    notes: 'Required 1+ year of experience',
  },
  {
    id: 'sat-930-kids-boxing',
    day: 'SATURDAY',
    startTime: '9:30 AM',
    endTime: '10:20 AM',
    title: 'Kids Boxing',
    category: 'kids',
    level: 'kids',
    trialEligible: true,
  },
  {
    id: 'sat-930-mma-int',
    day: 'SATURDAY',
    startTime: '9:30 AM',
    endTime: '10:20 AM',
    title: 'MMA - Intermediate',
    category: 'mma',
    level: 'intermediate',
    trialEligible: true,
    notes: 'Required 1+ year of experience',
  },
  {
    id: 'sat-1200-wrestling-beginners',
    day: 'SATURDAY',
    startTime: '12:00 PM',
    endTime: '1:30 PM',
    title: 'Wrestling Beginners',
    category: 'wrestling',
    level: 'beginners',
    trialEligible: true,
  },
  {
    id: 'sat-1130-boxing-int',
    day: 'SATURDAY',
    startTime: '11:30 AM',
    endTime: '1:00 PM',
    title: 'Boxing - Intermediate',
    category: 'boxing',
    level: 'intermediate',
    trialEligible: true,
    notes: 'Required 1+ year of experience',
  },
  {
    id: 'sat-100-beginners',
    day: 'SATURDAY',
    startTime: '1:00 PM',
    endTime: '2:30 PM',
    title: 'Boxing Beginners',
    category: 'boxing',
    level: 'beginners',
    trialEligible: true,
  },
];
